/* global localData, validateEmailInput */
// *******************************************************************************
// Word count
// *******************************************************************************
const textareas = document.querySelectorAll('.project-info textarea.mod-input, .profile textarea.mod-input');

textareas.forEach((textarea) => {
  const parent = textarea.closest('.project-info .form-group , .profile .form-group');
  const wordCounter = parent.querySelector('.textarea-counter');
  const maxLength = textarea.getAttribute('maxlength');

  if (wordCounter) {
    // eslint-disable-next-line no-param-reassign
    textarea.oninput = function checkLength() {
      wordCounter.innerHTML = maxLength - textarea.value.length;
    };
  }
});

if (document.querySelector('#project-submit-form')) {
  const signupHackForm = (() => {
    const r = {
      signUp: document.querySelector('#project-submit-form'),
      button: document.querySelector('#project-submit-form .btn--project-submit-button'),
      sendAjax: () => {
        r.isValid = true;
        const formData = {};
        r.signUp.querySelectorAll('input, textarea').forEach((input) => {
          const type = input.tagName === 'TEXTAREA' ? input.tagName : input.getAttribute('type');
          switch (type) {
            case 'hidden':
            case 'text':
            case 'TEXTAREA':
              formData[input.name] = input.value.trim();
              if (typeof input.getAttribute('required') === 'string' && !formData[input.name]) {
                input.closest('div').classList.add('is-validation-failed');
                r.isValid = false;
              } else {
                input.closest('div').classList.remove('is-validation-failed');
              }
              break;
            case 'email':
              formData[input.name] = input.value.trim();
              if (typeof input.getAttribute('required') === 'string') {
                if (!validateEmailInput(formData[input.name])) {
                  input.closest('div').classList.add('is-validation-failed');
                  r.isValid = false;
                } else {
                  input.closest('div').classList.remove('is-validation-failed');
                }
              }
              break;
            default:
          }
        });
        if (r.isValid) {
          const ajax = new XMLHttpRequest();
          const formInfo = new FormData();
          formInfo.append('action', 'newHackatonSignUp');
          formInfo.append('nonce', r.signUp.dataset.nonce);
          formInfo.append('id', localData.id);
          formInfo.append('inputs', JSON.stringify(formData));
          ajax.open('POST', localData.siteURL, true);
          ajax.onload = function () {
            const response = JSON.parse(ajax.responseText);
            r.signUp.innerHTML = response.data.message;
            r.signUp.scrollIntoView({ behavior: 'smooth', block: 'center' });
          };
          ajax.send(formInfo);
        }
      },
      initButton: () => {
        r.button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          r.sendAjax();
        });
      },
    };
    return {
      initialize: () => {
        r.initButton();
      },
    };
  })();
  signupHackForm.initialize();
}
if (document.querySelector('form.submit-info-form .project-info__inner, .rate-block')) {
  const editProjectForm = (() => {
    const r = {
      editForm: document.querySelector('form.submit-info-form'),
      button: document.querySelector('.footer-info-project .submit-button'),
      thumbnailButton: document.querySelector('form.submit-info-form .project-info__inner .project-thumbnail button'),
      addNewLinkButton: document.querySelectorAll('form.submit-info-form .project-info__inner .links-list .add-more-button'),
      previewImage: document.querySelector('form.submit-info-form #main-hackaton-image'),
      loading: false,
      links: 1,
      sendAjax: () => {
        r.isValid = true;
        const formInfo = new FormData();
        const formData = {};
        r.editForm.querySelectorAll('input[type="hidden"], input[type="text"], input[type="file"], .radio-button-list, textarea, .checkbox-list, .checkbox--secondary, .dropdown, .links-list__inner, .rate-block').forEach((input) => {
          let type = input.tagName === 'TEXTAREA' ? input.tagName : input.getAttribute('type');
          type = r.getCorrectInput(type, input);
          switch (type) {
            case 'checkbox--secondary': {
              const check = input.querySelector('input[type="checkbox"]');
              formData[check.name] = JSON.stringify({
                type: 'checkbox',
                value: check.checked,
              });
              r.addOrRemoveValidationClass(check, check.checked, input.closest('div'));
              break;
            }
            case 'radio-button-list':
            case 'dropdown': {
              const radioB = input.querySelectorAll('input[type="radio"]');
              let value = '';
              radioB.forEach((radio) => {
                if (radio.checked) {
                  value = radio.value;
                }
              });
              formData[radioB[0].name] = JSON.stringify({
                type: (type === 'dropdown') ? 'dropdown' : 'radio',
                value,
              });
              r.addOrRemoveValidationClass(radioB[0], value, type === 'dropdown' ? input.closest('.dropdown') : input.closest('.radio-button-list'));
              break;
            }
            case 'links-list__inner': {
              const text = input.querySelectorAll('input[type="text"]');
              const valueList = [];
              text.forEach((textarea, k) => {
                if (k < 6) {
                  valueList.push(textarea.value);
                }
              });
              formData[text[0].name] = JSON.stringify({
                type: 'links',
                value: valueList,
              });
              r.addOrRemoveValidationClass(text[0], valueList[0], input.closest('.links-list'));
              break;
            }
            case 'checkbox-list': {
              const checkboxes = input.querySelectorAll('input[type="checkbox"]');
              const valueC = [];
              checkboxes.forEach((check) => {
                if (check.checked) {
                  valueC.push(check.value);
                }
              });
              formData[checkboxes[0].name] = JSON.stringify({
                type: 'checkboxes',
                value: valueC,
              });
              r.addOrRemoveValidationClass(checkboxes[0], valueC.length, input.closest('.checkbox-list'));
              break;
            }
            case 'hidden': {
              formData.action = input.value;
              break;
            }
            case 'TEXTAREA':
            case 'text': {
              if (input.closest('.stars-block')) {
                const inputBox = input.closest('.stars-block');
                const checkboxes = inputBox.querySelectorAll('input');
                let result = 0;
                checkboxes.forEach((item) => {
                  if (item.checked) {
                    result = item.value;
                  }
                });
                const comment = inputBox.querySelector('TEXTAREA');
                formData[comment.name] = JSON.stringify({
                  type: 'stars',
                  stars: result,
                  comment: comment.value,
                });
                r.addOrRemoveValidationClass(input, comment.value, inputBox.querySelector('.form-group'));
              } else if (!input.closest('.links-list')) {
                formData[input.name] = JSON.stringify({
                  type,
                  value: input.value.trim(),
                });
                r.addOrRemoveValidationClass(input, input.value, input.closest('div'));
              }
              break;
            }
            case 'file': {
              const closestBox = input.closest('.upload-box');
              if (closestBox) {
                let number = 0;
                const { files } = input;
                Object.keys(files).forEach((key) => {
                  formInfo.append(`${input.name}_${key}`, files[key]);
                  number = key;
                });
                const valueItems = [];
                const uploadedFiles = input.closest('.upload-box').querySelectorAll('span.upload-box__list-text');
                uploadedFiles.forEach((item) => {
                  if (item.dataset.fullname != null) {
                    valueItems.push({ name: item.dataset.fullname, fullname: item.innerHTML });
                    number = 1;
                  }
                });
                formData[input.name] = JSON.stringify({
                  type,
                  value: number,
                  uploaded: valueItems,
                });
                r.addOrRemoveValidationClass(input, number, input.closest('.upload-box'));
              }
              break;
            }
            default:
              break;
          }
        });
        if (r.isValid && !r.loading) {
          r.loading = true;
          const ajax = new XMLHttpRequest();
          const fileHtml = document.getElementById('main-hackaton-image');
          if (fileHtml) {
            const file = fileHtml.files[0];
            if (file) {
              formInfo.append('image', file);
            }
          }
          Object.keys(formData).forEach((key) => {
            formInfo.append(key, formData[key]);
          });
          formInfo.append('id', localData.id);
          ajax.open('POST', localData.siteURL, true);
          ajax.onload = function () {
            const response = JSON.parse(ajax.responseText);
            r.loading = false;
            if (response.data.status === 200) {
              window.location.href = response.data.url;
            }
          };
          ajax.send(formInfo);
        }
      },
      getCorrectInput: (type, input) => {
        if (input.classList.contains('radio-button-list')) {
          return 'radio-button-list';
        }
        if (input.classList.contains('checkbox-list')) {
          return 'checkbox-list';
        }
        if (input.classList.contains('checkbox--secondary')) {
          return 'checkbox--secondary';
        }
        if (input.classList.contains('dropdown')) {
          return 'dropdown';
        }
        if (input.classList.contains('links-list__inner')) {
          return 'links-list__inner';
        }
        return type;
      },
      addOrRemoveValidationClass: (input, value, closest) => {
        if (typeof input.getAttribute('required') === 'string' && !value) {
          closest.classList.add('is-validation-failed');
          r.isValid = false;
        } else {
          closest.classList.remove('is-validation-failed');
        }
      },
      initButton: () => {
        r.button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          r.sendAjax();
        });
      },
      initLinksMoreButton: () => {
        r.addNewLinkButton.forEach((button) => {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const input = e.target.closest('.links-list__inner').querySelector('.links-list__item');
            const clone = input.cloneNode(true);
            const cloneInput = clone.querySelector('input');
            clone.querySelector('.links-list__link-delete').hidden = false;
            cloneInput.name = `new_link_${r.links}`;
            cloneInput.value = '';
            cloneInput.id = `new_link_${r.links}`;
            e.target.closest('.links-list__inner').querySelector('.add-more-button').before(clone);
            r.links += 1;
            r.initRemoveLinksButton();
          });
        });
      },
      initRemoveLinksButton: () => {
        const linkModule = r.editForm.querySelectorAll('.links-list');
        linkModule.forEach((module) => {
          const deleteButtons = module.querySelectorAll('button.links-list__link-delete');
          deleteButtons.forEach((button, k) => {
            if (k > 0) {
              button.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                e.target.closest('.links-list__item').remove();
              });
            } else {
              // eslint-disable-next-line no-param-reassign
              button.hidden = true;
            }
          });
        });
      },
      initThumbImageButton: () => {
        r.thumbnailButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          document.querySelector('.project-thumbnail input').click();
        });
      },
      initThumbPreview: () => {
        r.previewImage.addEventListener('change', () => {
          document.querySelector('.project-thumbnail__image img').src = URL.createObjectURL(r.previewImage.files[0]);
        });
      },
    };
    return {
      initialize: () => {
        r.initButton();
        r.initLinksMoreButton();
        r.initRemoveLinksButton();
        if (r.thumbnailButton) {
          r.initThumbImageButton();
        }
        if (r.previewImage) {
          r.initThumbPreview();
        }
      },
    };
  })();
  editProjectForm.initialize();
}
